import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ScholarshipCategoryActions from './scholarshipcategory.actions';
import { ScholarshipCategoryService } from '../../services/scholarshipcategory.service';

@Injectable()
export class ScholarshipCategoryEffects {
  loadScholarshipCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipCategoryActions.loadScholarshipCategory),
      exhaustMap((_) =>
        this.scholarshipCategoryService.getScholarshipCategory().pipe(
          map((data) =>
            ScholarshipCategoryActions.loadScholarshipCategorySuccess({
              scholarshipCategory: data,
            })
          ),
          catchError((error) =>
            of(
              ScholarshipCategoryActions.loadScholarshipCategoryFailure({
                error,
              })
            )
          )
        )
      )
    )
  );

  addScholarshipCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipCategoryActions.addScholarshipCategory),
      concatMap(({ newScholarshipCategory }) =>
        this.scholarshipCategoryService
          .createScholarshipCategory(newScholarshipCategory)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return ScholarshipCategoryActions.addScholarshipCategorySuccess({
                newScholarshipCategory: data,
              });
            }),
            catchError((error) =>
              of(
                ScholarshipCategoryActions.addScholarshipCategoryFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  updateScholarshipCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipCategoryActions.updateScholarshipCategory),
      map((action) => action.updateScholarshipCategory),
      concatMap((updateScholarshipCategory) =>
        this.scholarshipCategoryService
          .updateScholarshipCategory(updateScholarshipCategory)
          .pipe(
            map((_) => {
              this.notification.success('Updated Successfully');
              return ScholarshipCategoryActions.updateScholarshipCategorySuccess(
                {
                  updateScholarshipCategory: updateScholarshipCategory,
                }
              );
            }),
            catchError((error) =>
              of(
                ScholarshipCategoryActions.updateScholarshipCategoryFailure({
                  error: error.message,
                })
              )
            )
          )
      )
    )
  );

  removeScholarshipCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipCategoryActions.removeScholarshipCategory),
      map((action) => action.ids),
      concatMap((ids) =>
        this.scholarshipCategoryService.deleteScholarshipCategory(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ScholarshipCategoryActions.removeScholarshipCategorySuccess({
              ids,
            });
          }),
          catchError((error) =>
            of(
              ScholarshipCategoryActions.updateScholarshipCategoryFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private scholarshipCategoryService: ScholarshipCategoryService,
    private notification: NotificationService
  ) {}
}
